import { render, staticRenderFns } from "./FileTable.vue?vue&type=template&id=0aa9dd24&scoped=true&"
import script from "./FileTable.vue?vue&type=script&lang=ts&"
export * from "./FileTable.vue?vue&type=script&lang=ts&"
import style0 from "./FileTable.vue?vue&type=style&index=0&id=0aa9dd24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa9dd24",
  null
  
)

export default component.exports